import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-eth-cashin-form',
  templateUrl: './eth-cashin-form.component.html',
  // Mantiene el layout del formulario en el grid declarado por el padre.
  styles: [':host { display: contents; }'],
})
export class EthCashinFormComponent {
  @Input() ctx!: any;
}
